module.exports = __webpack_public_path__ + "static/images/components/Nation/images/flag-all-ussr.fb1c1e9c.png";


//////////////////
// WEBPACK FOOTER
// ./components/Nation/images/flag-all-ussr.png
// module id = 2622
// module chunks = 11